<template>
	<el-container class="group-page">
		<resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="group-aside-width">
			<div class="header">
				<el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-button plain class="add-btn" icon="el-icon-plus" title="创建群聊" @click="onCreateGroup()" v-if="isAdmin"></el-button>
			</div>
			<el-scrollbar class="group-items">
				<div v-for="(groups, i) in groupValues" :key="i">
					<div class="letter">{{ groupKeys[i] }}</div>
					<div v-for="group in groups" :key="group.id">
						<group-item :group="group" :active="group.id == activeGroup.id"
							@click.native="onActiveItem(group)">
						</group-item>
					</div>
					<div v-if="i < groupValues.length - 1" class="divider"></div>
				</div>
			</el-scrollbar>
		</resizable-aside>
		<el-container class="container" :class="{ show: isMobile && activeGroup.id }">
			<div class="header" v-show="activeGroup.id">
				<span class="back-btn el-icon-arrow-left" @click="activeGroup = {}"></span>
				<span class="title">{{ activeGroup.showGroupName }}({{ showMembers.length }})</span>
			</div>
			<div class="container-box" v-show="activeGroup.id">
				<div class="group-info">
					<div>
						<file-upload v-show="isOwner" class="avatar-uploader" :action="groupAvatarAction" :showLoading="true"
							:maxSize="maxSize" @success="onUploadSuccess" :uploadParams="groupAvatarParams"
							:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
							<img v-if="activeGroup.headImage" :src="activeGroup.headImage" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</file-upload>
						<head-image v-show="!isOwner" class="avatar" :size="160" :url="activeGroup.headImage"
							:name="activeGroup.showGroupName" radius="10%" @click.native="showFullImage()">
						</head-image>
						<el-button class="send-btn" icon="el-icon-position" type="primary" @click="onSendMessage()">发消息
						</el-button>
					</div>
					<el-form class="form" label-width="130px" :model="activeGroup" :rules="rules" size="small"
						ref="groupForm">
						<el-form-item label="群聊名称" prop="name">
							<el-input v-model="activeGroup.name" :disabled="!isOwner" maxlength="20"></el-input>
						</el-form-item>
						<el-form-item label="群主">
							<el-input :value="ownerName" disabled></el-input>
						</el-form-item>
						<el-form-item label="群名备注">
							<el-input v-model="activeGroup.remarkGroupName" :placeholder="activeGroup.name"
								maxlength="20"></el-input>
						</el-form-item>
						<el-form-item label="我在本群的昵称">
							<el-input v-model="activeGroup.remarkNickName" maxlength="20"
								:placeholder="userStore.userInfo.nickName"></el-input>
						</el-form-item>
						<el-form-item label="群公告">
							<el-input v-model="activeGroup.notice" :disabled="!isOwner" type="textarea" :rows="3"
								maxlength="1024" placeholder="群主未设置"></el-input>
						</el-form-item>
						<el-form-item v-if="isOwner" label="全员禁言">
							<el-switch v-model="activeGroup.isMuted" active-text="已禁言" inactive-text="未禁言"
								@change="handleMuteChange"></el-switch>
						</el-form-item>
						<el-form-item v-if="isOwner" label="禁止私聊">
							<el-switch v-model="activeGroup.isForbidPrivateChat" active-text="已禁止" inactive-text="未禁止"
								@change="handleForbidPrivateChatChange"></el-switch>
						</el-form-item>
						<el-form-item v-if="isOwner" label="群机器人">
							<el-button type="primary" size="small" @click="onManageRobot()">机器人管理</el-button>
						</el-form-item>
						<div>
							<el-button type="warning" @click="onInvite()">邀请</el-button>
							<el-button type="success" @click="onSaveGroup()">保存</el-button>
							<el-button type="danger" v-show="!isOwner" @click="onQuit()">退出</el-button>
							<el-button type="danger" v-show="isOwner" @click="onDissolve()">解散</el-button>
						</div>
					</el-form>
				</div>
				<el-divider content-position="center"></el-divider>
				<el-scrollbar ref="scrollbar" :style="'height: ' + scrollHeight + 'px'">
					<div class="member-items">
						<div class="member-tools">
							<div class="tool-btn" title="邀请好友进群聊" @click="onInvite()">
								<i class="el-icon-plus"></i>
							</div>
							<div class="tool-text">邀请</div>
							<add-group-member ref="addGroupMember" :groupId="activeGroup.id" :members="groupMembers"
								@reload="loadGroupMembers"></add-group-member>
						</div>
						<div class="member-tools" v-if="isOwner">
							<div class="tool-btn" title="选择成员移出群聊" @click="onRemove()">
								<i class="el-icon-minus"></i>
							</div>
							<div class="tool-text">移除</div>
							<group-member-selector ref="removeSelector" title="选择成员进行移除" :group="activeGroup"
								@complete="onRemoveComplete"></group-member-selector>
						</div>
						<div v-for="(member, idx) in showMembers" :key="member.id">
							<group-member v-if="idx < showMaxIdx" class="member-item" :member="member"></group-member>
						</div>
					</div>
				</el-scrollbar>
			</div>
		</el-container>

		<!-- 机器人管理对话框 -->
		<el-dialog title="机器人管理" :visible.sync="robotManageDialogVisible" width="500px">
			<div class="robot-manage">
				<el-scrollbar class="robot-list">
					<div v-for="robot in robots" :key="robot.id" class="robot-item" @click="editRobot(robot)">
						<div class="robot-avatar">
							<img v-if="robot.avatar" :src="robot.avatar" class="avatar">
							<i v-else class="el-icon-robot avatar-placeholder"></i>
						</div>
						<div class="robot-info">
							<div class="robot-name">{{ robot.name }}</div>
							<div class="robot-desc">由群主添加</div>
						</div>
						<div class="robot-arrow">
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
					
					<!-- 添加机器人 -->
					<div class="add-robot-item" @click="onAddRobot">
						<div class="add-icon">
							<i class="el-icon-plus"></i>
						</div>
						<div class="add-text">添加机器人</div>
						<div class="add-desc">多款丰富的精选机器人</div>
					</div>
				</el-scrollbar>
			</div>
		</el-dialog>

		<!-- 机器人编辑对话框 -->
		<el-dialog title="设置" :visible.sync="robotDialogVisible" width="500px">
			<div class="robot-setting">
				<div class="robot-avatar-section">
					<file-upload class="avatar-uploader" :action="robotAvatarAction" :showLoading="true"
						:maxSize="maxSize" @success="onRobotAvatarUploadSuccess" :uploadParams="robotAvatarParams"
						:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
						<img v-if="currentRobot.avatar" :src="currentRobot.avatar" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</file-upload>
				</div>

				<el-form :model="currentRobot" label-width="100px" size="small">
					<el-form-item label="机器人名字">
						<el-input v-model="currentRobot.name" maxlength="20"></el-input>
					</el-form-item>

					<el-form-item label="接收群组">
						<el-input v-model="activeGroup.name" readonly></el-input>
					</el-form-item>

					<el-form-item label="消息推送">
						<el-select v-model="currentRobot.isEnabled" style="width: 100%">
							<el-option label="开启" :value="true"></el-option>
							<el-option label="关闭" :value="false"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="Webhook">
						<div class="webhook-container">
							<el-input v-model="fullWebhookUrl" readonly style="flex: 1"></el-input>
							<el-button type="warning" size="small" @click="resetWebhookUrl">重置</el-button>
							<el-button type="primary" size="small" @click="copyFullWebhookUrl">复制</el-button>
						</div>
						<div class="warning-text">*请保管好 Webhook 地址，不要公布在外部网站上，泄露有安全风险</div>
					</el-form-item>

					<el-form-item label="密钥">
						<div class="webhook-container">
							<el-input v-model="currentRobot.secret" readonly style="flex: 1"></el-input>
							<el-button type="primary" size="small" @click="copySecret(currentRobot.secret)">复制</el-button>
						</div>
					</el-form-item>
				</el-form>

				<div class="dialog-footer">
					<el-button type="danger" @click="onDeleteRobot">删除</el-button>
					<el-button @click="robotDialogVisible = false">取消</el-button>
					<el-button type="primary" @click="saveRobot">完成</el-button>
				</div>
			</div>
		</el-dialog>
	</el-container>
</template>


<script>
import GroupItem from '../components/group/GroupItem';
import FileUpload from '../components/common/FileUpload';
import GroupMember from '../components/group/GroupMember.vue';
import AddGroupMember from '../components/group/AddGroupMember.vue';
import GroupMemberSelector from '../components/group/GroupMemberSelector.vue';
import HeadImage from '../components/common/HeadImage.vue';
import ResizableAside from "../components/common/ResizableAside.vue";
import { pinyin } from 'pinyin-pro';

export default {
	name: "group",
	components: {
		GroupItem,
		GroupMember,
		FileUpload,
		AddGroupMember,
		GroupMemberSelector,
		HeadImage,
		ResizableAside
	},
	data() {
		return {
			searchText: "",
			maxSize: 5 * 1024 * 1024,
			activeGroup: {},
			groupMembers: [],
			robots: [],
			showAddGroupMember: false,
			showMaxIdx: 150,
			robotManageDialogVisible: false,
			robotDialogVisible: false,
			currentRobot: {},
			rules: {
				name: [{
					required: true,
					message: '请输入群聊名称',
					trigger: 'blur'
				}]
			}
		};
	},
	computed: {
		isMobile() {
			return window.innerWidth <= 768;
		},
		isAdmin() {
			return this.userStore.userInfo && this.userStore.userInfo.isAdmin;
		},
		fullWebhookUrl() {
			return `https://xxdatapush.cn/box-api/group/robot/webhook/${this.currentRobot.webhookUrl}`;
		},
		ownerName() {
			let member = this.groupMembers.find(m => m.userId == this.activeGroup.ownerId);
			return member && member.showNickName;
		},
		isOwner() {
			return this.activeGroup.ownerId == this.userStore.userInfo.id;
		},
		groupAvatarAction() {
			return `/avatar/upload`;
		},
		groupAvatarParams() {
			return {
				type: 'group',
				id: this.activeGroup.id
			};
		},
		robotAvatarAction() {
			return `/avatar/upload`;
		},
		robotAvatarParams() {
			return {
				type: 'robot',
				id: this.currentRobot.id
			};
		},
		imageAction() {
			return `/image/upload?thumbSize=20`;
		},
		groupMap() {
			let map = new Map();
			this.groupStore.groups.forEach((g) => {
				if (g.quit || (this.searchText && !g.showGroupName.includes(this.searchText))) {
					return;
				}
				let letter = this.firstLetter(g.showGroupName).toUpperCase();
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (map.has(letter)) {
					map.get(letter).push(g);
				} else {
					map.set(letter, [g]);
				}
			})
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				if (a[0] == '#' || b[0] == '#') {
					return b[0].localeCompare(a[0])
				}
				return a[0].localeCompare(b[0])
			})
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		groupKeys() {
			return Array.from(this.groupMap.keys());
		},
		groupValues() {
			return Array.from(this.groupMap.values());
		},
		showMembers() {
			return this.groupMembers.filter((m) => !m.quit)
		},
		scrollHeight() {
			return Math.min(300, 80 + this.showMembers.length / 10 * 80);
		}
	},
	methods: {
		onCreateGroup() {
			this.$prompt('请输入群聊名称', '创建群聊', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /\S/,
				inputErrorMessage: '请输入群聊名称'
			}).then(o => {
				let data = {
					name: o.value
				}
				this.$http({
					url: `/group/create?groupName=${o.value}`,
					method: 'post',
					data: data
				}).then((group) => {
					this.groupStore.addGroup(group);
					this.onActiveItem(group)
					this.$message.success('创建成功');
				})
			})
		},
		onActiveItem(group) {
			this.showMaxIdx = 150;
			this.activeGroup = JSON.parse(JSON.stringify(group));
			this.groupMembers = [];
			this.robots = [];
			this.loadGroupMembers();
			this.loadRobots();
		},
		onInvite() {
			this.$refs.addGroupMember.open();
		},
		onRemove() {
			let hideIds = [this.activeGroup.ownerId];
			this.$refs.removeSelector.open(50, [], [], hideIds);
		},
		onRemoveComplete(members) {
			let userIds = members.map(m => m.userId);
			let data = {
				groupId: this.activeGroup.id,
				userIds: userIds
			}
			this.$http({
				url: "/group/members/remove",
				method: 'delete',
				data: data
			}).then(() => {
				this.loadGroupMembers();
				this.$message.success(`您移除了${userIds.length}位成员`);
			})
		},
		onUploadSuccess(data) {
			this.activeGroup.headImage = data;
			this.activeGroup.headImageThumb = data;
		},
		onSaveGroup() {
			this.$refs['groupForm'].validate((valid) => {
				if (valid) {
					let vo = this.activeGroup;
					this.$http({
						url: "/group/modify",
						method: "put",
						data: vo
					}).then((group) => {
						this.groupStore.updateGroup(group);
						this.$message.success("修改成功");
					})
				}
			});
		},
		onDissolve() {
			this.$confirm(`确认要解散'${this.activeGroup.name}'吗?`, '确认解散?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/group/delete/${this.activeGroup.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success(`群聊'${this.activeGroup.name}'已解散`);
					this.groupStore.removeGroup(this.activeGroup.id);
					this.reset();
				});
			})
		},
		onQuit() {
			this.$confirm(`确认退出'${this.activeGroup.showGroupName}',并清空聊天记录吗？`, '确认退出?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/group/quit/${this.activeGroup.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success(`您已退出'${this.activeGroup.name}'`);
					this.groupStore.removeGroup(this.activeGroup.id);
					this.chatStore.removeGroupChat(this.activeGroup.id);
					this.reset();
				});
			})
		},
		onSendMessage() {
			let chat = {
				type: 'GROUP',
				targetId: this.activeGroup.id,
				showName: this.activeGroup.showGroupName,
				headImage: this.activeGroup.headImageThumb,
				isDnd: this.activeGroup.isDnd
			};
			this.chatStore.openChat(chat);
			this.chatStore.setActiveChat(0);
			this.$router.push("/home/chat");
		},
		handleMuteChange(val) {
			this.$http({
				url: '/group/mute',
				method: 'put',
				data: {
					groupId: this.activeGroup.id,
					isMuted: val
				}
			}).then(() => {
				this.groupStore.setMute(this.activeGroup.id, val);
				this.$message.success(val ? '已开启全员禁言' : '已关闭全员禁言');
			}).catch(() => {
				this.activeGroup.isMuted = !val;
				this.$message.error('操作失败');
			});
		},
		handleForbidPrivateChatChange(val) {
			this.$http({
				url: '/group/forbid-private-chat',
				method: 'put',
				data: {
					groupId: this.activeGroup.id,
					isForbidPrivateChat: val
				}
			}).then(() => {
				this.groupStore.setForbidPrivateChat(this.activeGroup.id, val);
				this.$message.success(val ? '已禁止群成员私聊' : '已允许群成员私聊');
			}).catch(() => {
				this.activeGroup.isForbidPrivateChat = !val;
				this.$message.error('操作失败');
			});
		},
		onScroll(e) {
			const scrollbar = e.target;
			if (scrollbar.scrollTop + scrollbar.clientHeight >= scrollbar.scrollHeight - 30) {
				if (this.showMaxIdx < this.showMembers.length) {
					this.showMaxIdx += 50;
				}
			}
		},
		showFullImage() {
			if (this.activeGroup.headImage) {
				this.$eventBus.$emit("openFullImage", this.activeGroup.headImage);
			}
		},
		loadGroupMembers() {
			this.$http({
				url: `/group/members/${this.activeGroup.id}`,
				method: "get"
			}).then((members) => {
				this.groupMembers = members;
			})
		},
		loadRobots() {
			if (!this.activeGroup.id) return;
			this.$http({
				url: `/group/robot/list/${this.activeGroup.id}`,
				method: "get"
			}).then((robots) => {
				this.robots = robots;
			})
		},
		onManageRobot() {
		this.robotManageDialogVisible = true;
	},
	onAddRobot() {
		this.$prompt('请输入机器人名称', '添加机器人', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			inputPattern: /\S/,
			inputErrorMessage: '请输入机器人名称'
		}).then(o => {
			let data = {
				groupId: this.activeGroup.id,
				name: o.value
			}
			this.$http({
				url: `/group/robot/create`,
				method: 'post',
				data: data
			}).then((robot) => {
				this.robots.push(robot);
				this.currentRobot = JSON.parse(JSON.stringify(robot));
				this.robotManageDialogVisible = false;
				this.robotDialogVisible = true;
				this.$message.success('添加成功');
			})
		})
	},
	editRobot(robot) {
		this.currentRobot = JSON.parse(JSON.stringify(robot));
		this.robotManageDialogVisible = false;
		this.robotDialogVisible = true;
	},
		onRobotAvatarUploadSuccess(data) {
			this.currentRobot.avatar = data;
		},
		saveRobot() {
			let data = {
				id: this.currentRobot.id,
				name: this.currentRobot.name,
				avatar: this.currentRobot.avatar,
				isEnabled: this.currentRobot.isEnabled
			}
			this.$http({
				url: `/group/robot/update`,
				method: 'put',
				data: data
			}).then((updatedRobot) => {
				let index = this.robots.findIndex(r => r.id === updatedRobot.id);
				if (index !== -1) {
					this.robots[index] = updatedRobot;
				}
				this.$message.success('保存成功');
				this.robotDialogVisible = false;
			}).catch(() => {
				this.$message.error('保存失败');
			});
		},
		resetWebhookUrl() {
			this.$confirm('确定要重置Webhook地址吗？重置后旧地址将失效。', '确认重置', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/group/robot/reset-webhook/${this.currentRobot.id}`,
					method: 'put'
				}).then((updatedRobot) => {
					this.currentRobot.webhookUrl = updatedRobot.webhookUrl;
					this.currentRobot.secret = updatedRobot.secret;
					this.$message.success('Webhook地址已重置');
				}).catch(() => {
					this.$message.error('重置失败');
				});
			});
		},
		copyFullWebhookUrl() {
			navigator.clipboard.writeText(this.fullWebhookUrl).then(() => {
				this.$message.success('完整Webhook地址已复制');
			}).catch(() => {
				this.$message.error('复制失败');
			});
		},
		onDeleteRobot() {
			this.$confirm('确认删除该机器人吗？', '确认删除', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/group/robot/delete/${this.currentRobot.id}`,
					method: 'delete'
				}).then(() => {
					this.robots = this.robots.filter(r => r.id !== this.currentRobot.id);
					this.$message.success('删除成功');
					this.robotDialogVisible = false;
				})
			})
		},
		copySecret(secret) {
			navigator.clipboard.writeText(secret).then(() => {
				this.$message.success('密钥已复制');
			}).catch(() => {
				this.$message.error('复制失败');
			});
		},
		reset() {
			this.activeGroup = {};
			this.groupMembers = [];
			this.robots = [];
		},
		firstLetter(strText) {
			let pinyinOptions = {
				toneType: 'none',
				type: 'normal'
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	mounted() {
		let scrollWrap = this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap');
		scrollWrap.addEventListener('scroll', this.onScroll);
	}
}
</script>

<style lang="scss" scoped>
.group-page {
	width: 100%;
	height: 100%;
	display: flex;

	.header {
		height: 50px;
		display: flex;
		align-items: center;
		padding: 0 8px;

		.add-btn {
			padding: 5px !important;
			margin: 5px;
			font-size: 16px;
			border-radius: 50%;
		}
	}

	.group-items {
		flex: 1;

		.letter {
			text-align: left;
			font-size: var(--im-larger-size-larger);
			padding: 5px 15px;
			color: var(--im-text-color-light);
		}
	}

	// 响应式设计
	@media screen and (max-width: 768px) {
		.el-container {
			display: block;
			width: 100%;
			height: 100%;
		}

		// 左侧群列表占满全屏
		resizable-aside {
			width: 100% !important;
			min-width: 100% !important;
			max-width: 100% !important;
			height: 100%;
		}

		.header {
			height: 44px;
			border-bottom: var(--im-border);
		}

		// 右侧群信息区域在移动端全屏显示
		.container {
			display: none;
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100% !important;
			z-index: 1002;
			background: #fff;
			border-left: none;
			
			&.show {
				display: flex;
			}
			
			.header {
				display: flex;
				align-items: center;
				padding: 0 12px;
				border-bottom: var(--im-border);
				
				.back-btn {
					display: block;
					font-size: 20px;
					cursor: pointer;
					color: var(--im-text-color);
					margin-right: 10px;
					width: 20px;
					height: 20px;
					line-height: 20px;
				}
				
				.title {
					flex: 1;
					text-align: center;
					font-size: var(--im-font-size-large);
				}
			}
		}
	}

	@media screen and (max-width: 480px) {
		.header {
			height: 40px;
		}
	}

	.container {
		display: flex;
		flex-direction: column;

		.header {
			display: flex;
			justify-content: space-between;
			padding: 0 12px;
			line-height: 50px;
			font-size: var(--im-font-size-larger);
			border-bottom: var(--im-border);
		}

		.el-divider--horizontal {
			margin: 16px 0;
		}

		.container-box {
			overflow: auto;
			padding: 20px;
			flex: 1;

			.group-info {
				display: flex;
				padding: 5px 20px;

				.form {
					flex: 1;
					padding-left: 40px;
					max-width: 700px;
				}

				.avatar-uploader {
					--width: 160px;
					text-align: left;

					.el-upload {
						border: 1px dashed #d9d9d9 !important;
						border-radius: 6px;
						cursor: pointer;
						position: relative;
						overflow: hidden;
					}

					.el-upload:hover {
						border-color: #409EFF;
					}

					.avatar-uploader-icon {
						font-size: 28px;
						color: #8c939d;
						width: var(--width);
						height: var(--width);
						line-height: var(--width);
						text-align: center;
					}

					.avatar {
						width: var(--width);
						height: var(--width);
						display: block;
					}
				}

				.send-btn {
					margin-top: 12px;
				}
			}

			.member-items {
				padding: 0 12px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				text-align: center;

				.member-item {
					margin-right: 5px;
				}

				.member-tools {
					display: flex;
					flex-direction: column;
					align-items: center;
					width: 60px;

					.tool-btn {
						width: 38px;
						height: 38px;
						line-height: 38px;
						border: var(--im-border);
						font-size: 14px;
						cursor: pointer;
						box-sizing: border-box;

						&:hover {
							border: #aaaaaa solid 1px;
						}
					}

					.tool-text {
						font-size: var(--im-font-size-smaller);
						text-align: center;
						width: 100%;
						height: 30px;
						line-height: 30px;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden
					}
				}

			}
		}
	}

	.robot-manage {
		.robot-list {
			max-height: 400px;

			.robot-item {
				display: flex;
				align-items: center;
				padding: 15px;
				border-bottom: 1px solid #f0f0f0;
				cursor: pointer;

				&:hover {
					background-color: #f5f5f5;
				}

				.robot-avatar {
					margin-right: 15px;

					.avatar {
						width: 48px;
						height: 48px;
						border-radius: 50%;
						display: block;
					}

					.avatar-placeholder {
						font-size: 48px;
						color: #c0c4cc;
					}
				}

				.robot-info {
					flex: 1;

					.robot-name {
						font-size: 16px;
						font-weight: 500;
						margin-bottom: 4px;
					}

					.robot-desc {
						font-size: 14px;
						color: #909399;
					}
				}

				.robot-arrow {
					color: #c0c4cc;
				}
			}

			.add-robot-item {
				display: flex;
				align-items: center;
				padding: 15px;
				cursor: pointer;

				&:hover {
					background-color: #f5f5f5;
				}

				.add-icon {
					width: 48px;
					height: 48px;
					border: 1px dashed #d9d9d9;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 15px;

					.el-icon-plus {
						font-size: 24px;
						color: #c0c4cc;
					}
				}

				.add-text {
					font-size: 16px;
					font-weight: 500;
					margin-bottom: 4px;
				}

				.add-desc {
					font-size: 14px;
					color: #909399;
				}
			}
		}
	}

	.robot-setting {
		.robot-avatar-section {
			display: flex;
			justify-content: center;
			margin-bottom: 20px;

			.avatar-uploader {
				--width: 80px;
				text-align: center;

				.avatar {
					width: var(--width);
					height: var(--width);
					border-radius: 50%;
					display: block;
				}

				.avatar-uploader-icon {
					font-size: 32px;
					color: #8c939d;
					width: var(--width);
					height: var(--width);
					line-height: var(--width);
					text-align: center;
				}
			}
		}

		.webhook-container {
			display: flex;
			align-items: center;
			gap: 10px;
		}

		.warning-text {
			color: #f56c6c;
			font-size: 12px;
			margin-top: 5px;
		}

		.dialog-footer {
			display: flex;
			justify-content: flex-end;
			margin-top: 20px;
			gap: 10px;
		}
	}

	/* 微信风格按钮颜色 */
	.el-button--primary {
		background-color: #07C160 !important;
		border-color: #07C160 !important;

		&:hover {
			background-color: #05a351 !important;
			border-color: #05a351 !important;
		}

		&:active {
			background-color: #048541 !important;
			border-color: #048541 !important;
		}
	}

	.el-button--success {
		background-color: #07C160 !important;
		border-color: #07C160 !important;

		&:hover {
			background-color: #05a351 !important;
			border-color: #05a351 !important;
		}
	}

	.el-button--danger {
		background-color: #ff4d4f !important;
		border-color: #ff4d4f !important;

		&:hover {
			background-color: #ff7875 !important;
			border-color: #ff7875 !important;
		}
	}

	.el-button--warning {
		background-color: #faad14 !important;
		border-color: #faad14 !important;

		&:hover {
			background-color: #ffc53d !important;
			border-color: #ffc53d !important;
		}
	}
}
</style>